"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StickinessPage = void 0;
const React = __importStar(require("react"));
const react_1 = require("react");
const StickinessDataProvider_1 = require("src/hello_assets/src/components/ui/loggedin/content/project/withData/features/stickiness/StickinessDataProvider");
const StickinessPageDataProvider_1 = require("src/hello_assets/src/components/ui/loggedin/content/project/withData/features/stickiness/StickinessPageDataProvider");
const StickinessPageModelProvider_1 = require("src/hello_assets/src/components/ui/loggedin/content/project/withData/features/stickiness/StickinessPageModelProvider");
const DataState_1 = require("src/hello_assets/src/components/ui/loggedin/content/project/withData/features/stickiness/state/data/DataState");
const StickinessPage = () => {
    (0, react_1.useEffect)(() => {
        setTimeout(() => window.scrollTo({ top: 0 }), 0);
    }, []);
    return React.createElement(StickinessDataProvider_1.StickinessDataProvider, null,
        React.createElement(StickinessPageModelProvider_1.StickinessPageModelProvider, null,
            React.createElement(StickinessPageDataProvider_1.StickinessPageDataProvider, null,
                React.createElement(DataState_1.DataState, null))));
};
exports.StickinessPage = StickinessPage;
